import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';

const oktaAuthConfig: OktaAuthOptions = {
    issuer: process.env.REACT_APP_OKTA_ISSUER || '',
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
};

export const oktaAuth = new OktaAuth(oktaAuthConfig);